var _rect, _rect2, _text, _text2, _rect3, _text3, _rect4, _text4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgItem4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 400,
    height: 250,
    viewBox: "0 0 400 250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 250,
    fill: "#fef3c7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 360,
    height: 210,
    rx: 8,
    fill: "white",
    stroke: "#f59e0b",
    strokeWidth: 2
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 80,
    fontFamily: "system-ui, sans-serif",
    fontSize: 24,
    fontWeight: 600,
    fill: "#b45309",
    textAnchor: "middle"
  }, "NoteNest Backend")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 115,
    fontFamily: "system-ui, sans-serif",
    fontSize: 14,
    fill: "#64748b",
    textAnchor: "middle"
  }, "Java 21 + Spring Boot 3.4 + PostgreSQL")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 140,
    width: 120,
    height: 60,
    rx: 4,
    fill: "#6366f1",
    opacity: 0.1,
    stroke: "#6366f1",
    strokeWidth: 1
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 178,
    fontFamily: "system-ui, sans-serif",
    fontSize: 12,
    fill: "#3730a3",
    textAnchor: "middle"
  }, "REST API")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 140,
    width: 120,
    height: 60,
    rx: 4,
    fill: "#ec4899",
    opacity: 0.1,
    stroke: "#ec4899",
    strokeWidth: 1
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 280,
    y: 178,
    fontFamily: "system-ui, sans-serif",
    fontSize: 12,
    fill: "#be185d",
    textAnchor: "middle"
  }, "Scalar Docs")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItem4);
export default __webpack_public_path__ + "static/media/item4.62dc5ab6bd4e43c778b2949ad62fa254.svg";
export { ForwardRef as ReactComponent };